/* global Notification, session, LS, Q, nf, dn, Function, Blinder */

// A unique identifier for this specific browser tab instance
const TAB_ID = Math.random().toString(36).slice(2, 10);

window.on("message", ev => {
    if (!ev.data || !/^\{/.test(ev.data)) {
        return;
    }
    try {
        var data = (ev.data || '{}').parsed;

        switch (data.signal) {
            case "#PONG":
                Q.i(ev, { title: "#PONG" });
                break;

            case "#WHO":
                Q.i(data.clients, { title: "#WHO <m bc hsp>[" + data.clients.length + "] wss-clients</m>" });
                break;
        }
    } catch (error) {
        console.log(error);
    }
});



class wss_cnx {
    conf_default = { chain: new Chain() }

    constructor(host, port, conf = { cb: nf, led: null }) {
        this.tail(this.conf_default);
        this.host = (host || location.hostname);
        this.port = (port || +session.wss_port || 7777);
        this.user = conf.user || session.domain_user;
        this.conf = conf;

        this.initTabOrchestration();
    }

    /**
     * Set up cross-tab leadership synchronization
     */
    initTabOrchestration() {
        var $ = this;

        // Claim leadership when this tab is clicked or focused
        window.on("focus", () => {
            //  console.log(`[Tab ${TAB_ID}] Claiming active socket lock.`);
            $.claimLeadership();
        });

        // Background tabs monitor if another tab has taken over control
        window.on('storage', (ev) => {
            if (ev.key === `wss_leader_${btoa($.name)}`) {
                if (ev.newValue && ev.newValue !== TAB_ID) {
                    // console.log(`[Tab ${TAB_ID}] Relinquishing socket to active Tab ${ev.newValue}.`);
                    $.closeConnection();
                }
            }
        });

        // Release the lease key on page unload/close
        window.on("beforeunload", () => {
            if (localStorage.getItem(`wss_leader_${btoa($.name)}`) === TAB_ID) {
                localStorage.removeItem(`wss_leader_${btoa($.name)}`);
            }
        });

        this.claimLeadership();
    }

    claimLeadership() {
        localStorage.setItem(`wss_leader_${btoa(this.name)}`, TAB_ID);
        if (!this.active) {
            this.open(this.conf);
        }
    }

    closeConnection() {
        if (this.socket) {
            this.socket.onopen = this.socket.onclose = this.socket.onerror = this.socket.onmessage = null;
            if (this.socket.readyState <= 1) {
                this.socket.close(1000, "Tab in background");
            }
            delete this.socket;
        }
        if (this.led) {
            this.led.remA("wss_connected").setA("title", "[ WSS ] STANDBY (Background Tab) ");
        }
    }

    open(conf = {}) {
        var $ = window.SOCK = this;

        if (localStorage.getItem(`wss_leader_${btoa(this.name)}`) !== TAB_ID) {
            return this.chain;
        }

        if (this.socket) { this.closeConnection(); }

        var SK = new WebSocket('wss://' + this.host + ':' + this.port
            + '?'
            + btoa('du=' + this.user
                + "&k=" + session.wss_key
                + (Q.bool(localStorage.getItem("livereload")) ? "&livereload=1" : "")
            ));

        SK._id = Math.random().toString(36).slice(2, 8);
        this.socket = SK;

        SK.onopen = function (ev) {
            if (localStorage.getItem(`wss_leader_${btoa($.name)}`) !== TAB_ID) {
                $.closeConnection();
                return;
            }

            // console.log(`[Tab ${TAB_ID}] OPEN SOCKET`, SK._id);
            if (window.Notification && Notification.permission !== "granted" && !$.requested_perm_launched) {
                $.request_notification_permission();
            }
            setTimeout(function () {
                if (SK.readyState === 1) {
                    SK.ok = true;
                    $.chain.resolve(true);
                    $.led && $.led.setA("wss_connected").setA("title", "[ WSS ] --> CONNECTED <-- ");//.tmpA("spark");
                    LS.pointer("wss_sockets." + btoa($.name), true);
                    if (conf.cb) {
                        conf.cb(conf);
                        delete conf.cb;
                    }
                } else {
                    dn("<wrn></wrn>MECANISMUL DE COMUNICARE SI IDENTIFICARE ESTE INCHIS...", "WSS PROBLEMS");
                    $.chain.reject();
                }
            }, 0);
        };

        SK.onclose = function (ev) {
            // console.log(`[Tab ${TAB_ID}] CLOSED`, SK._id);
            $.led && $.led.remA("wss_connected").tmpA("shake").setA("title", "[ WSS ] DIS-CONNECTED ");
            LS.pointer("wss_sockets." + btoa($.name), false);

            if (SK.ok && localStorage.getItem(`wss_leader_${btoa($.name)}`) === TAB_ID) {
                setTimeout($.reset.bind($), 500);
            }
        };

        SK.onerror = (ev) => {
            if (SK.ok && localStorage.getItem(`wss_leader_${btoa($.name)}`) === TAB_ID) {
                setTimeout($.reset.bind($), 1000);
            }
        };

        SK.onmessage = $.read.bind($);
        return $.chain;
    }

    read(e) {
        window.fire('message', e);
        try {
            var DATA = JSON.parse(e.data);
            if (Q.bool(DATA.message)) {
                var noti = new Notification(
                    (new Date).datetime,
                    {
                        body: DATA.message,
                        icon: '/favicon.ico'
                    });
                DATA.link && noti.addEventListener("click", () => {
                    window.open(DATA.link, '_blank');
                });
            }
            if (Q.bool(DATA.command)) {
                try {
                    var cmd_arr = DATA.command.split("#");
                    if (cmd_arr.length === 2) {
                        let cmd = cmd_arr[1];
                        Q.modules("~.wss_commands").then(M => {
                            var A = !DATA.args ? [] : Array.isArray(DATA.args) ? DATA.args : [DATA.args];
                            if (M[cmd] instanceof Function) {
                                M[cmd](...A);
                            } else {
                                dn("<sad fll style='margin:0 1em .5em 0'></sad> wss_socket requires <m bc>" + cmd + "</m> resolver!", "ERROR");
                            }
                        });
                    } else {
                        eval(DATA.command);
                    }
                } catch (e) {
                    console.log(e, DATA);
                }
            }
            this.chain.resolve(DATA);
        } catch (exc) {
            console.log("BROKEN SOCKET MESSAGE!", exc);
            this.chain.reject(exc);
        }
    }

    push(obj = {}) {
        var $ = this;
        if (this.socket && this.socket.readyState === 1) {
            if (!obj.data) { obj.data = {}; }
            ['message', 'command', 'args'].map(p => { obj.data[p] = obj[p] });
            let to = obj.users || obj.to;
            if (!to) { return; }
            if (!Array.isArray(to)) { to = [to]; }
            to = to.map(e => /:/.test(e) ? e : e + ":" + location.host);

            var o = JSON.stringify({
                users: to,
                data: JSON.stringify(obj.data)
            }) + "<EOF>";
            this.chain = new Chain();
            this.socket.send(o);
        } else {
            // Re-verify leader status before blind execution
            if (localStorage.getItem(`wss_leader_${btoa(this.name)}`) === TAB_ID) {
                setTimeout(function () {
                    $.reset({ cb: () => $.push(obj) });
                }, 0);
            }
        }
        return this.chain;
    }

    show(rgx = '') {
        if (!rgx || typeof rgx === 'string') {
            return this.push({ users: ["#WHO"], data: { grep: rgx } });
        } else {
            console.log("RegExp REQUIRED!");
        }
    }

    ping() {
        return this.push({ users: ["#PING"] });
    }

    reset(conf = {}) {
        if (localStorage.getItem(`wss_leader_${btoa(this.name)}`) === TAB_ID && !this.quiet) {
            this.open(conf);
        }
    }

    force_active(conf = {}) {
        if (this.active) {
            this.chain.resolve(1);
        } else {
            this.claimLeadership();
            this.open(conf).then(this.chain.resolve);
        }
        return this.chain;
    }

    set led(element) {
        var led = this.led_element = typeof element === "string" ? Q(element) : element;
        led.on("click", () => {
            if (this.state !== 1) {
                this.claimLeadership();
            }
        });
        return;
    }

    get led() { return this.led_element; }
    get name() { return this.user + ":" + this.host; }
    get state() { return this.socket ? this.socket.readyState : 3; }
    get active() { return this.socket && this.socket.readyState === 1; }

    request_notification_permission() {
        this.requested_perm_launched = true;
        const permission = Notification.permission;

        if (permission === "granted") return;

        if (permission === "denied") {
            Blinder.show({
                title: `<icon fill style='font-size:2em;color:red;transform:translateY(7px)'>warning</icon> MUST ENABLE NOTIFICATION ON <c> ${location}</c>`,
                init: (_i) => {
                    _i.html = `<div style='font-size:1.3em;margin:2em;'>Notificarile sunt o parte functionala <b>IMPORTANTA</b> pentru ADR-NE...</div>`;
                },
                _ok: () => { Notification.requestPermission(); }
            });
            return;
        }

        Notification.requestPermission().then(p => {
            if (p === "granted") {
                new Notification("Notifications Enabled", {
                    body: "You'll receive updates about tasks and clarifications.",
                    icon: '/favicon.ico'
                });
            }
        });
    }
}